(() => {
  const toNumber = (value) => {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  };

  const parseDate = (value) => {
    if (!value) return 0;
    const t = Date.parse(value);
    return Number.isFinite(t) ? t : 0;
  };

  const debounce = (fn, delayMs) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delayMs);
    };
  };

  const normalize = (s) => (s || "").toString().toLowerCase().trim();

  const slugify = (s) => (s || "").toString().toLowerCase().trim().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");

  const decodeHtml = (() => {
    const t = document.createElement("textarea");
    return (value) => {
      t.innerHTML = (value || "").toString();
      return t.value;
    };
  })();

  const swatchColor = (key) => {
    switch (key) {
      case "blue": return "#2f83ff";
      case "red": return "#ff3b3b";
      case "green": return "#2dd96f";
      case "yellow": return "#ffd400";
      case "purple": return "#a56bff";
      case "orange": return "#ff9a2f";
      case "pink": return "#ff4fd8";
      case "white": return "#ffffff";
      case "gold": return "#caa44a";
      case "silver": return "#c9ccd1";
      case "brown": return "#8b5a2b";
      case "grey":
      case "gray": return "#9aa3ad";
      default: return "#3a4048";
    }
  };

  const initSection = (root) => {
    const endpoint = (root.getAttribute("data-ag-endpoint") || "").toString().trim();
    const limitAttr = Number(root.getAttribute("data-ag-limit"));
    const defaultSortBy = (root.getAttribute("data-ag-default-sort-by") || "created_at").toString().trim() || "created_at";
    const defaultSortOrderRaw = (root.getAttribute("data-ag-default-sort-order") || "desc").toString().trim().toLowerCase();
    const defaultSortOrder = defaultSortOrderRaw === "asc" ? "asc" : "desc";

    const grid = root.querySelector("[data-ag-grid]");
    const empty = root.querySelector("[data-ag-empty]");
    const status = root.querySelector("[data-ag-status]");
    const pagerWrap = root.querySelector("[data-ag-pager]");
    const prevPageBtn = root.querySelector("[data-ag-page-prev]");
    const nextPageBtn = root.querySelector("[data-ag-page-next]");
    const pagerNumbers = root.querySelector("[data-ag-page-numbers]");

    const resetTop = root.querySelector("[data-ag-reset-top]");
    const resetBottom = root.querySelector("[data-ag-reset-bottom]");
    const applyBtn = root.querySelector("[data-ag-apply]");
    const overlay = root.querySelector("[data-ag-overlay]");
    const closeBtn = root.querySelector("[data-ag-close]");
    const drawerTitle = root.querySelector("[data-ag-drawer-title]");
    const openButtons = Array.from(root.querySelectorAll("[data-ag-open]"));
    const sortByRadios = Array.from(root.querySelectorAll("input[type='radio'][data-ag-sort-by]"));
    const sortOrder = root.querySelector("[data-ag-sort-order]");

    const themeChecks = Array.from(root.querySelectorAll("input[type='checkbox'][data-ag-filter='theme']"));
    const colorChecks = Array.from(root.querySelectorAll("input[type='checkbox'][data-ag-filter='color']"));
    const orientationChecks = Array.from(root.querySelectorAll("input[type='checkbox'][data-ag-filter='orientation']"));

    const themeTabBtns = Array.from(root.querySelectorAll("[data-ag-collection-tab]"));
    let activeCollection = "";

    const setUrlCollection = (value) => {
      const url = new URL(window.location.href);
      if (value) {
        url.searchParams.set("collection", slugify(value));
      } else {
        url.searchParams.delete("collection");
      }
      history.replaceState(null, "", url.toString());
    };
    const searchInput = root.querySelector("[data-ag-search]");

    const activeFilters = root.querySelector("[data-ag-active-filters]");
    const activeList = root.querySelector("[data-ag-active-list]");
    const clearAll = root.querySelector("[data-ag-clear-all]");

    const sortByToApi = (raw) => {
      const v = asString(raw).trim();
      const n = normalize(v).replace(/_/g, "-");
      switch (n) {
        case "newest":
        case "created-at":
        case "created_at":
          return "created_at";
        case "best-seller":
        case "best-seller-score":
        case "best_seller_score":
          return "best_seller_score";
        case "most-popular":
        case "most-popular-score":
        case "most_popular_score":
          return "most_popular_score";
        case "trending":
        case "trending-score":
        case "trending_score":
          return "trending_score";
        default:
          return v;
      }
    };

    const applySortDefaults = () => {
      if (sortByRadios.length) {
        let found = false;
        sortByRadios.forEach((r) => {
          const ok = sortByToApi(r.value) === sortByToApi(defaultSortBy);
          r.checked = ok;
          if (ok) found = true;
        });
        if (!found) sortByRadios[0].checked = true;
      }
      if (sortOrder) sortOrder.value = defaultSortOrder;
    };

    const groups = Array.from(root.querySelectorAll("[data-ag-group]"));

    groups.forEach((g) => {
      const btn = g.querySelector("[data-ag-toggle]");
      if (!btn) return;
      btn.addEventListener("click", () => {
        const collapsed = g.classList.toggle("is-collapsed");
        btn.setAttribute("aria-expanded", collapsed ? "false" : "true");
      });
    });

    Array.from(root.querySelectorAll("[data-ag-swatch]")).forEach((sw) => {
      const key = sw.getAttribute("data-ag-swatch");
      sw.style.background = swatchColor(key);
    });

    const modalRoot = root.querySelector("[data-ag-modal]");
    const modalOverlay = root.querySelector("[data-ag-modal-overlay]");
    const modalDialog = root.querySelector("[data-ag-modal-dialog]");
    const modalClose = root.querySelector("[data-ag-modal-close]");
    const modalTitle = root.querySelector("[data-ag-modal-title]");
    const modalTheme = root.querySelector("[data-ag-modal-theme]");
    const modalMedia = root.querySelector("[data-ag-modal-media]");
    const modalPrompt = root.querySelector("[data-ag-modal-prompt]");
    const modalGenerate = root.querySelector("[data-ag-modal-generate]");
    const modalPrint = root.querySelector("[data-ag-modal-print]");
    const modalIconLeft = root.querySelector("[data-ag-modal-icon-left]");
    const modalIconRight = root.querySelector("[data-ag-modal-icon-right]");

    const asString = (v) => (v == null ? "" : String(v));

    const pickFirst = (obj, keys) => {
      if (!obj) return "";
      for (const key of keys) {
        const v = obj[key];
        if (typeof v === "string" && v.trim()) return v.trim();
        if (typeof v === "number" && Number.isFinite(v)) return String(v);
        if (v && typeof v === "object") {
          const url = v.url || v.src || v.href;
          if (typeof url === "string" && url.trim()) return url.trim();
        }
      }
      return "";
    };

    const extractItems = (payload) => {
      if (Array.isArray(payload)) return payload;
      if (!payload || typeof payload !== "object") return [];
      const candidates = ["data", "items", "results", "art_gallery", "artworks", "records"];
      for (const k of candidates) {
        if (Array.isArray(payload[k])) return payload[k];
      }
      return [];
    };

    const isMobile = () =>
      window.matchMedia && window.matchMedia("(max-width: 860px)").matches;

    const wrapEl = root.querySelector("#filter-mainwrap");

    // Mobile panel refs
    const mobOrientationChecks = Array.from(root.querySelectorAll("input[data-ag-filter-mob='orientation']"));
    const mobSortByRadios      = Array.from(root.querySelectorAll("input[data-ag-sort-mob]"));
    const mobApplyBtn          = root.querySelector("[data-ag-mob-apply]");
    const mobResetBtn          = root.querySelector("[data-ag-mob-reset]");
    const mobSearchInput       = root.querySelector("[data-ag-mob-search]");

    // Copy desktop → mobile (called when drawer opens)
    const syncToMobile = () => {
      mobOrientationChecks.forEach(mc => {
        const dc = orientationChecks.find(d => d.value === mc.value);
        mc.checked = dc ? dc.checked : false;
      });
      mobSortByRadios.forEach(mr => {
        const dr = sortByRadios.find(d => d.value === mr.value);
        mr.checked = dr ? dr.checked : false;
      });
      if (mobSearchInput && searchInput) mobSearchInput.value = searchInput.value;
    };

    // Copy mobile → desktop (called when Apply is pressed)
    const syncFromMobile = () => {
      mobOrientationChecks.forEach(mc => {
        const dc = orientationChecks.find(d => d.value === mc.value);
        if (dc) dc.checked = mc.checked;
      });
      mobSortByRadios.forEach(mr => {
        const dr = sortByRadios.find(d => d.value === mr.value);
        if (dr) dr.checked = mr.checked;
      });
      if (mobSearchInput && searchInput) searchInput.value = mobSearchInput.value;
    };

    const getSelected = (inputs) =>
      inputs
        .filter((i) => i.checked)
        .map((i) => asString(i.value).trim())
        .filter(Boolean);

    const readStateFromDom = () => ({
      themes: getSelected(themeChecks),
      colors: getSelected(colorChecks),
      orientations: getSelected(orientationChecks),
      collection_name: activeCollection,
      sort_by: sortByToApi(sortByRadios.find((r) => r.checked)?.value || defaultSortBy) || "created_at",
      sort_order:
        asString(sortOrder?.value || defaultSortOrder).trim().toLowerCase() === "asc"
          ? "asc"
          : "desc",
    });

    const updateActiveFilters = () => {
      if (!activeFilters || !activeList) return;
      const dom = readStateFromDom();
      const titleize = (v) => {
        const s = asString(v).trim();
        if (!s) return "";
        return s.charAt(0).toUpperCase() + s.slice(1);
      };

      activeList.textContent = "";

      const sortLabel = (() => {
        const key = asString(dom.sort_by).trim();
        const order = asString(dom.sort_order).trim().toLowerCase() === "asc" ? "asc" : "desc";
        const map = {
          created_at: "Newest",
          best_seller_score: "Best Seller",
          most_popular_score: "Most Popular",
          trending_score: "Trending",
        };
        const base = map[key] || key || "Sort";
        return `${base}${order === "asc" ? " ↑" : " ↓"}`;
      })();

      const filterGroups = [
        { kind: "theme", label: "Theme", values: dom.themes },
        { kind: "color", label: "Color", values: dom.colors },
        { kind: "orientation", label: "Orientation", values: dom.orientations.map(titleize) },
      ].filter((g) => (g.values || []).length);

      const sortIsDefault =
        sortByToApi(dom.sort_by) === sortByToApi(defaultSortBy) &&
        asString(dom.sort_order).trim().toLowerCase() === asString(defaultSortOrder).trim().toLowerCase();

      const groups = [
        ...(sortIsDefault ? [] : [{ kind: "sort", label: "Sort", values: [sortLabel] }]),
        ...filterGroups,
      ];

      if (!groups.length) {
        activeFilters.hidden = true;
        if (clearAll) clearAll.hidden = true;
        return;
      }

      groups.forEach((g, idx) => {
        const wrap = document.createElement("div");
        wrap.className = "ag__chipGroup";
        wrap.setAttribute("data-ag-chip-group", "");
        wrap.dataset.kind = g.kind;

        const label = document.createElement("div");
        label.className = "ag__chipGroupLabel";
        label.textContent = `${g.label}:`;

        const items = document.createElement("div");
        items.className = "ag__chipGroupItems";

        (g.values || []).forEach((v, idx) => {
  // Hide chips beyond index 2 (first 3 visible)
  if (idx > 2) return;

  const btn = document.createElement("button");
  btn.type = "button";
  btn.className = "ag__chip ag__chip--item";
  btn.setAttribute("data-ag-chip", "");
  btn.dataset.kind = g.kind;
  btn.dataset.value = v;

  const text = document.createElement("span");
  text.className = "ag__chipText";
  text.textContent = v;

  const x = document.createElement("span");
  x.className = "ag__chipX";
  x.setAttribute("aria-hidden", "true");
  x.textContent = "×";

  btn.appendChild(text);
  btn.appendChild(x);
  items.appendChild(btn);
});

// "+ N more" badge if values exceed 3
const total = (g.values || []).length;
if (total > 3) {
  const more = document.createElement("span");
  more.className = "ag__chip ag__chip--more";
  more.textContent = `+${total - 3} more`;
  items.appendChild(more);
}

        wrap.appendChild(label);
        wrap.appendChild(items);
        activeList.appendChild(wrap);

        // Only show AND between actual filter categories (theme/color/orientation).
        if (idx !== groups.length - 1 && g.kind !== "sort") {
          const and = document.createElement("div");
          and.className = "ag__and";
          and.textContent = "AND";
          activeList.appendChild(and);
        }

        // Separator between Sort and the first filter group.
        if (g.kind === "sort" && filterGroups.length) {
          const sep = document.createElement("div");
          sep.className = "ag__sep";
          sep.textContent = "•";
          activeList.appendChild(sep);
        }
      });

      activeFilters.hidden = false;
      if (clearAll) clearAll.hidden = false;
    };

    const writeStateToDom = (next) => {
      const setChecks = (inputs, values) => {
        const set = new Set((values || []).map((v) => normalize(v)));
        inputs.forEach((i) => {
          i.checked = set.has(normalize(i.value));
        });
      };

      setChecks(themeChecks, next.themes);
      setChecks(colorChecks, next.colors);
      setChecks(orientationChecks, next.orientations);

      const sortBy = asString(next.sort_by || defaultSortBy).trim() || defaultSortBy;
      let found = false;
      sortByRadios.forEach((r) => {
        const ok = asString(r.value) === sortBy;
        r.checked = ok;
        if (ok) found = true;
      });
      if (!found && sortByRadios[0]) sortByRadios[0].checked = true;

      if (sortOrder) sortOrder.value = next.sort_order || defaultSortOrder;
    };

    const apiState = {
      page: 1,
      limit: Number.isFinite(limitAttr) && limitAttr > 0 ? Math.floor(limitAttr) : 25,
      total: null,
      totalPages: null,
      hasNextPage: false,
      hasPrevPage: false,
      busy: false,
      abort: null,
    };

    const setStatus = (tone, text) => {
      if (!status) return;
      status.hidden = !text;
      status.textContent = text || "";
      if (tone) status.setAttribute("data-tone", tone);
      else status.removeAttribute("data-tone");
    };

    const renderState = {
      mode: "server",
      shown: 0,
      lastRawCount: 0,
      clientFiltered: [],
    };

    const toIntOrNull = (value) => {
      const n = Number(value);
      if (!Number.isFinite(n)) return null;
      return Math.trunc(n);
    };

    const applyPagination = ({ page, limit, total, totalPages, hasNextPage, hasPrevPage }) => {
      const nextPage = Math.max(1, toIntOrNull(page) || apiState.page || 1);
      const nextLimit = Math.max(1, toIntOrNull(limit) || apiState.limit || 25);
      const nextTotal = toIntOrNull(total);
      const nextTotalPagesRaw = toIntOrNull(totalPages);
      const nextTotalPages = nextTotalPagesRaw != null ? Math.max(0, nextTotalPagesRaw) : null;

      apiState.page = nextPage;
      apiState.limit = nextLimit;
      apiState.total = nextTotal;
      apiState.totalPages = nextTotalPages;

      if (typeof hasNextPage === "boolean") {
        apiState.hasNextPage = hasNextPage;
      } else if (nextTotalPages != null) {
        apiState.hasNextPage = nextTotalPages > 0 && nextPage < nextTotalPages;
      } else if (nextTotal != null) {
        apiState.hasNextPage = nextPage * nextLimit < nextTotal;
      } else {
        apiState.hasNextPage = false;
      }

      if (typeof hasPrevPage === "boolean") {
        apiState.hasPrevPage = hasPrevPage;
      } else {
        apiState.hasPrevPage = nextPage > 1;
      }
    };

    const updatePager = ({ busy = false, forceShow = false } = {}) => {
      if (!pagerWrap) return;
      const hasMultiplePages =
        (typeof apiState.totalPages === "number" && apiState.totalPages > 1) ||
        apiState.hasNextPage ||
        apiState.hasPrevPage;

      pagerWrap.hidden = !(forceShow || hasMultiplePages);

      if (pagerNumbers) {
        pagerNumbers.textContent = "";
        const totalPages = typeof apiState.totalPages === "number" ? apiState.totalPages : null;
        if (totalPages && totalPages > 0) {
          const maxVisible = 5;
          const start = Math.max(1, Math.min(apiState.page - 2, totalPages - maxVisible + 1));
          const end = Math.min(totalPages, start + maxVisible - 1);

          for (let p = start; p <= end; p += 1) {
            const btn = document.createElement("button");
            btn.type = "button";
            btn.className = "ag__pagerNum";
            if (p === apiState.page) btn.classList.add("is-active");
            btn.textContent = String(p);
            btn.dataset.page = String(p);
            btn.disabled = !!busy || p === apiState.page;
            pagerNumbers.appendChild(btn);
          }
        }
      }

      if (prevPageBtn) prevPageBtn.disabled = !!busy || !apiState.hasPrevPage;
      if (nextPageBtn) nextPageBtn.disabled = !!busy || !apiState.hasNextPage;
    };

    const buildUrl = () => {
      const base = endpoint.replace(/\/+$/, "");
      const params = new URLSearchParams();
      const dom = readStateFromDom();
      if (dom.collection_name) params.set("collection_name", dom.collection_name);
      if (dom.themes.length === 1) params.set("theme", dom.themes[0]);
      if (dom.colors.length === 1) params.set("color", dom.colors[0]);
      if (dom.orientations.length === 1) params.set("orientation", dom.orientations[0]);

      params.set("sort_by", dom.sort_by || "created_at");
      params.set("sort_order", dom.sort_order || "desc");
      params.set("page", String(apiState.page));
      params.set("limit", String(apiState.limit));
      return `${base}/?${params.toString()}`;
    };

    const applySearch = () => {
      if (!grid) return;
      const term = normalize(searchInput ? searchInput.value : "");
      Array.from(grid.querySelectorAll("[data-ag-card]")).forEach((card) => {
        if (!term) { card.hidden = false; return; }
        const title = normalize(card.dataset.title || "");
        const desc = normalize(card.dataset.description || "");
        const themeLabel = normalize(card.dataset.themeLabel || "");
        card.hidden = !(title.includes(term) || desc.includes(term) || themeLabel.includes(term));
      });
    };

    const cardFromItem = (item) => {
      const title = pickFirst(item, ["title", "name"]) || "Artwork";
      const theme = pickFirst(item, ["theme"]) || "";
      const description = pickFirst(item, ["prompt", "description", "desc"]) || "";
      const thumbUrl = pickFirst(item, [
        "thumbnail_image_url",
        "thumbnail_url",
        "thumbnail_image",
        "thumbnail",
        "thumb",
        "thumb_url",
      ]);
      const mainUrl = pickFirst(item, ["main_image_url", "image_url", "main_image", "image", "url"]);
      const imgUrl = thumbUrl || mainUrl;
      const printUrl = pickFirst(item, ["print_url", "printUrl", "print_link", "printLink"]);

      const article = document.createElement("article");
      article.className = "ag__card";
      article.setAttribute("data-ag-card", "");
      article.dataset.title = title;
      article.dataset.description = description;
      article.dataset.themeLabel = theme || "Theme Name";
      article.dataset.highQualityImage = mainUrl;
      if (printUrl) {
        article.dataset.printUrl = printUrl;
        article.dataset.printLabel = "Print";
      }

      const media = document.createElement("div");
      media.className = "ag__media";
      // const generateMediaBtn = document.createElement("button");
      // generateMediaBtn.className = "ag__generate-media-btn";
      // generateMediaBtn.innerHTML = `
      //   <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      //     <path d="M9.91992 0.4646C10.4053 -0.0208038 11.1956 -0.0214438 11.6816 0.4646L12.0244 0.806396C12.5105 1.29188 12.5104 2.08311 12.0244 2.56909L2.6582 11.9353C2.41523 12.1783 2.09603 12.2995 1.77734 12.2996C1.45862 12.2996 1.1395 12.1783 0.896484 11.9353L0.553711 11.5925C0.0677218 11.107 0.0677651 10.3168 0.553711 9.83081L9.91992 0.4646ZM1.01855 10.2966C0.907281 10.408 0.84668 10.5559 0.84668 10.7126C0.846739 10.8693 0.907255 11.0163 1.01855 11.1277L1.36133 11.4705C1.59041 11.6995 1.96328 11.6995 2.19238 11.4705L3.47168 10.1902L2.29785 9.01636L1.01855 10.2966ZM11.2168 0.929443C10.9877 0.700382 10.6148 0.700377 10.3857 0.929443L2.76367 8.55151L3.9375 9.72534L11.5596 2.10327C11.6709 1.99194 11.7314 1.84405 11.7314 1.68726C11.7314 1.53063 11.6709 1.38357 11.5596 1.27222L11.2168 0.929443Z" fill="white" stroke="white" stroke-width="0.2"/>
      //     <path d="M7.66211 8.44238C7.78742 8.44238 7.898 8.52504 7.93164 8.64648C8.06909 9.14437 8.17904 9.42506 8.37109 9.61719C8.56314 9.80921 8.8438 9.91923 9.3418 10.0566C9.46296 10.0903 9.54688 10.2007 9.54688 10.3262C9.54673 10.4515 9.46295 10.5621 9.3418 10.5957C8.84383 10.7331 8.56313 10.8423 8.37109 11.0342C8.17905 11.2262 8.06909 11.5067 7.93164 12.0049C7.89811 12.1257 7.78765 12.21 7.66211 12.21C7.53679 12.2099 7.4261 12.1264 7.39258 12.0049C7.25514 11.5071 7.14516 11.2273 6.95312 11.0352C6.76111 10.8431 6.48135 10.7331 5.9834 10.5957C5.8621 10.5622 5.77847 10.4516 5.77832 10.3262C5.77832 10.2006 5.86199 10.0901 5.9834 10.0566C6.48152 9.91919 6.76207 9.80923 6.9541 9.61719C7.14602 9.42515 7.25517 9.14447 7.39258 8.64648C7.42612 8.52578 7.53669 8.44248 7.66211 8.44238ZM7.66211 9.55469C7.57374 9.73662 7.47429 9.88606 7.34863 10.0117C7.2227 10.1376 7.07224 10.2367 6.88965 10.3252C7.07247 10.4136 7.22254 10.5136 7.34863 10.6396C7.47426 10.7652 7.57299 10.9149 7.66113 11.0967C7.7496 10.9145 7.85071 10.7654 7.97656 10.6396C8.10222 10.5141 8.25155 10.4145 8.43359 10.3262C8.25133 10.2379 8.1014 10.1375 7.97559 10.0117C7.84994 9.88602 7.75027 9.73661 7.66211 9.55469Z" fill="white" stroke="white" stroke-width="0.1"/>
      //     <path d="M2.39453 2.02515C2.51976 2.02529 2.63049 2.10783 2.66406 2.22925C2.84328 2.87775 2.99234 3.25185 3.25098 3.5105C3.50955 3.76903 3.88317 3.91832 4.53125 4.09741C4.65262 4.13089 4.73725 4.24138 4.7373 4.36694C4.7373 4.49255 4.65266 4.60298 4.53125 4.63647C3.88304 4.81564 3.50858 4.9648 3.25 5.22339C3.05618 5.41731 2.92449 5.67649 2.79492 6.06714L2.66406 6.50464C2.63056 6.62537 2.51995 6.7086 2.39453 6.70874C2.26915 6.70874 2.15858 6.62619 2.125 6.50464C1.94581 5.85624 1.79665 5.48203 1.53809 5.22339C1.27946 4.96476 0.905217 4.81563 0.256836 4.63647C0.135431 4.60298 0.0517578 4.49255 0.0517578 4.36694C0.0518118 4.24139 0.135462 4.1309 0.256836 4.09741C0.905207 3.91822 1.27947 3.76912 1.53809 3.5105C1.79661 3.25186 1.94587 2.87756 2.125 2.22925C2.15861 2.10855 2.26907 2.02515 2.39453 2.02515ZM2.39453 3.17749C2.2673 3.47835 2.12394 3.71371 1.93262 3.90503C1.74146 4.09618 1.50654 4.23978 1.20605 4.36694C1.50651 4.49407 1.74146 4.63777 1.93262 4.82886C2.1237 5.01994 2.2674 5.2551 2.39453 5.55542C2.52166 5.25503 2.66534 5.01997 2.85645 4.82886C3.04755 4.63775 3.28264 4.49408 3.58301 4.36694C3.2827 4.23982 3.04752 4.09611 2.85645 3.90503C2.66519 3.71371 2.52174 3.47832 2.39453 3.17749Z" fill="white" stroke="white" stroke-width="0.1"/>
      //     </svg>
      //   <span>Generate Similar</span>
      // `;
      // generateMediaBtn.addEventListener("click", function (event) {
      //   const article = event.target.closest(".ag__card");
      //   const description = article.dataset.description;
      //   const theme = article.dataset.themeLabel;
      //   generationProcess(description, theme);
      // });
      // media.appendChild(generateMediaBtn);

      const printOverlay = document.createElement("a");
      printOverlay.className = "ag__printOverlay";
      printOverlay.href = "#";
      printOverlay.textContent = "Print";
      printOverlay.addEventListener("click", function(e) {
        e.preventDefault();
        purchaseProcess(mainUrl);
      });
      media.appendChild(printOverlay);

      if (imgUrl) {
        const img = document.createElement("img");
        img.className = "ag__img";
        img.loading = "lazy";
        img.alt = title;
        img.src = mainUrl;
        img.dataset.highQualityMainImage = mainUrl;
        media.appendChild(img);
      } else {
        const ph = document.createElement("div");
        ph.className = "ag__img ag__img--ph";
        ph.setAttribute("aria-hidden", "true");
        media.appendChild(ph);
      }

      // const info = document.createElement("div");
      // info.className = "ag__info";

      // const textWrap = document.createElement("div");
      // textWrap.className = "ag__text";

      // const h = document.createElement("h4");
      // h.className = "ag__name";
      // h.textContent = title;

      // const meta = document.createElement("div");
      // meta.className = "ag__meta";
      // meta.textContent = theme || "Theme Name";

      // const desc = document.createElement("p");
      // desc.className = "ag__desc";
      // desc.textContent = description;
      // if (!description) desc.hidden = true;

      // textWrap.appendChild(h);
      // textWrap.appendChild(meta);
      // textWrap.appendChild(desc);

      // const actions = document.createElement("div");
      // actions.className = "ag__actions";

      // const details = document.createElement("a");
      // details.className = "ag__details";
      // details.href = "#";
      // details.textContent = "View Details";
      // details.setAttribute("data-ag-details", "");

      // const print = document.createElement("a");
      // print.className = "ag__print";
      // print.href = printUrl || "#";
      // print.textContent = "Print";
      // print.addEventListener("click", function (event) {
      //   const article = event.target.closest(".ag__card");
      //   const mainImageLink = article.dataset.highQualityImage;
      //   purchaseProcess(mainImageLink);
      // });
      // if (!printUrl) print.hidden = true;

      // actions.appendChild(details);
      // actions.appendChild(print);

      // info.appendChild(textWrap);
      // info.appendChild(actions);

      article.appendChild(media);
      // article.appendChild(info);
      return article;
    };

    const renderItems = (items) => {
      if (!grid) return;
      grid.textContent = "";
      const list = Array.isArray(items) ? items : [];
      list.forEach((it) => grid.appendChild(cardFromItem(it)));
      if (empty) empty.hidden = list.length !== 0;
      renderState.shown = list.length;
      applySearch();
    };

    const extractPagination = (payload) => {
      if (!payload || typeof payload !== "object") return null;
      const p = payload.pagination;
      if (!p || typeof p !== "object") return null;
      return {
        total: p.total,
        page: p.page,
        limit: p.limit,
        totalPages: p.total_pages,
        hasNextPage: p.has_next_page,
        hasPrevPage: p.has_prev_page,
      };
    };

    const renderClientPage = () => {
      const totalItems = renderState.clientFiltered.length;
      const totalPages = totalItems === 0 ? 0 : Math.ceil(totalItems / apiState.limit);
      const page = totalPages === 0 ? 1 : Math.max(1, Math.min(apiState.page, totalPages));
      apiState.page = page;

      const from = (page - 1) * apiState.limit;
      const to = from + apiState.limit;
      renderItems(renderState.clientFiltered.slice(from, to));
      applyPagination({
        page,
        limit: apiState.limit,
        total: totalItems,
        totalPages,
        hasPrevPage: totalPages > 0 && page > 1,
        hasNextPage: totalPages > 0 && page < totalPages,
      });
      updatePager({ busy: false });
    };

    const showSkeletons = () => {
      if (!grid) return;
      grid.textContent = "";
      const count = Math.min(apiState.limit, 6);
      for (let i = 0; i < count; i++) {
        const article = document.createElement("article");
        article.className = "ag__card ag__card--skeleton";
        const media = document.createElement("div");
        media.className = "ag__media";
        article.appendChild(media);
        grid.appendChild(article);
      }
      if (empty) empty.hidden = true;
      if (status) { status.hidden = true; status.textContent = ""; }
    };

    const refresh = async () => {
      showSkeletons();
      if (!endpoint) {
        setStatus("bad", "Missing API endpoint (section setting).");
        renderItems([]);
        applyPagination({
          page: 1,
          limit: apiState.limit,
          total: 0,
          totalPages: 0,
          hasPrevPage: false,
          hasNextPage: false,
        });
        updatePager({ busy: false });
        return;
      }

      if (apiState.abort) apiState.abort.abort();
      apiState.abort = new AbortController();
      apiState.busy = true;
      updatePager({ busy: true, forceShow: true });

      try {
        const dom = readStateFromDom();
        const selectedThemes = dom.themes.map((t) => normalize(t));
        const selectedColors = dom.colors.map((c) => normalize(c));
        const selectedOrientations = dom.orientations.map((o) => normalize(o));

        const selectedCollection = normalize(dom.collection_name || "");

        const filterItems = (items) => {
          const list = Array.isArray(items) ? items : [];
          if (!selectedCollection && !selectedThemes.length && !selectedColors.length && !selectedOrientations.length) return list;
          return list.filter((it) => {
            const theme = normalize(pickFirst(it, ["theme"]));
            const orientation = normalize(pickFirst(it, ["orientation"]));

            const rawColors = pickFirst(it, ["color", "colors"]);
            const colors = rawColors
              ? rawColors
                  .split(",")
                  .map((p) => normalize(p))
                  .filter(Boolean)
              : [];

            if (selectedCollection && normalize(pickFirst(it, ["collection_name"])) !== selectedCollection) return false;
            if (selectedThemes.length && !selectedThemes.includes(theme)) return false;
            if (selectedOrientations.length && !selectedOrientations.includes(orientation)) return false;

            if (selectedColors.length) {
              const set = new Set(colors);
              let ok = false;
              for (const c of selectedColors) {
                if (set.has(c)) {
                  ok = true;
                  break;
                }
              }
              if (!ok) return false;
            }

            return true;
          });
        };

        const needsClientPaging =
          dom.themes.length > 1 || dom.colors.length > 1 || dom.orientations.length > 1;

        const fetchPage = async ({ page, limit, forceDom }) => {
          const base = endpoint.replace(/\/+$/, "");
          const params = new URLSearchParams();
          const d = forceDom || dom;

          // Only send single-value filters to the API to avoid accidental "no results" when multiple are selected.
          if (d.collection_name) params.set("collection_name", d.collection_name);
          if (d.themes.length === 1) params.set("theme", d.themes[0]);
          if (d.colors.length === 1) params.set("color", d.colors[0]);
          if (d.orientations.length === 1) params.set("orientation", d.orientations[0]);

          params.set("sort_by", d.sort_by || "created_at");
          params.set("sort_order", d.sort_order || "desc");
          params.set("page", String(page));
          params.set("limit", String(limit));

          const url = `${base}/?${params.toString()}`;
          const res = await fetch(url, {
            method: "GET",
            headers: { accept: "application/json" },
            signal: apiState.abort.signal,
          });

          const contentType = res.headers.get("content-type") || "";
          const payload = contentType.includes("application/json") ? await res.json() : await res.text();
          return { res, payload };
        };

        if (needsClientPaging) {
          const pageSize = Math.min(100, Math.max(25, apiState.limit));
          const maxPages = 10;

          const all = [];
          let totalPagesFromApi = null;

          for (let p = 1; p <= maxPages; p += 1) {
            const { res, payload } = await fetchPage({ page: p, limit: pageSize });
            if (!res.ok) {
              setStatus("bad", `Request failed (${res.status}).`);
              renderItems([]);
              applyPagination({
                page: 1,
                limit: apiState.limit,
                total: 0,
                totalPages: 0,
                hasPrevPage: false,
                hasNextPage: false,
              });
              updatePager({ busy: false });
              return;
            }

            const pagination = extractPagination(payload);
            if (pagination && Number.isFinite(Number(pagination.totalPages))) {
              totalPagesFromApi = Math.max(0, Number(pagination.totalPages));
            }

            const items = extractItems(payload);
            all.push(...items);

            if (items.length < pageSize) {
              break;
            }
            if (typeof totalPagesFromApi === "number" && p >= totalPagesFromApi) {
              break;
            }
          }

          renderState.clientFiltered = filterItems(all);
          renderState.mode = "client";
          setStatus(null, "");
          renderClientPage();
          return;
        }

        // Server paging mode (single/empty filters).
        const { res, payload } = await fetchPage({ page: apiState.page, limit: apiState.limit, forceDom: dom });
        if (!res.ok) {
          setStatus("bad", `Request failed (${res.status}).`);
          renderItems([]);
          applyPagination({
            page: apiState.page,
            limit: apiState.limit,
            total: 0,
            totalPages: 0,
            hasPrevPage: apiState.page > 1,
            hasNextPage: false,
          });
          updatePager({ busy: false });
          return;
        }

        const items = extractItems(payload);
        const filteredItems = filterItems(items);
        renderState.mode = "server";
        renderState.lastRawCount = Array.isArray(items) ? items.length : 0;
        setStatus(null, "");
        renderItems(filteredItems);

        const pagination = extractPagination(payload);
        if (pagination) {
          applyPagination({
            page: pagination.page,
            limit: pagination.limit,
            total: pagination.total,
            totalPages: pagination.totalPages,
            hasPrevPage: pagination.hasPrevPage,
            hasNextPage: pagination.hasNextPage,
          });
        } else {
          const legacyTotal =
            payload && typeof payload === "object"
              ? payload.total ?? payload.count ?? payload.total_count
              : null;
          const total = typeof legacyTotal === "number" && Number.isFinite(legacyTotal) ? legacyTotal : null;
          const totalPages =
            total == null ? null : total <= 0 ? 0 : Math.ceil(total / Math.max(1, apiState.limit));
          const hasNextPage =
            total != null
              ? apiState.page * apiState.limit < total
              : renderState.lastRawCount >= apiState.limit;
          applyPagination({
            page: apiState.page,
            limit: apiState.limit,
            total,
            totalPages,
            hasPrevPage: apiState.page > 1,
            hasNextPage,
          });
        }
        updatePager({ busy: false });
      } catch (err) {
        if (err?.name === "AbortError") return;
        setStatus("bad", `Network error: ${err?.message || String(err)}`);
        renderItems([]);
        applyPagination({
          page: apiState.page,
          limit: apiState.limit,
          total: 0,
          totalPages: 0,
          hasPrevPage: apiState.page > 1,
          hasNextPage: false,
        });
        updatePager({ busy: false });
      } finally {
        apiState.busy = false;
        apiState.abort = null;
      }
    };

    let drawerOpen = false;
    let drawerMode = "filters";
    let snapshot = readStateFromDom();

    const openDrawer = (mode) => {
      if (!isMobile()) return;
      snapshot = readStateFromDom();
      syncToMobile();
      drawerOpen = true;
      drawerMode = mode === "sort" ? "sort" : "filters";
      root.classList.add("ag--drawer-open");
      root.classList.toggle("ag--drawer-sort", drawerMode === "sort");
      if (drawerTitle) drawerTitle.textContent = drawerMode === "sort" ? "Sort By" : "Filters";
      if (applyBtn) applyBtn.textContent = drawerMode === "sort" ? "Apply" : "Apply Filters";
      if (resetBottom) resetBottom.hidden = drawerMode === "sort";
      if (overlay) overlay.hidden = false;
      if (wrapEl) wrapEl.style.zIndex = "9999";
      document.documentElement.classList.add("ag-lock");
    };

    const closeDrawer = ({ apply = false } = {}) => {
      if (!drawerOpen) return;
      if (!apply) writeStateToDom(snapshot);

      drawerOpen = false;
      root.classList.remove("ag--drawer-open");
      root.classList.remove("ag--drawer-sort");
      if (overlay) overlay.hidden = true;
      if (wrapEl) wrapEl.style.zIndex = "2";
      document.documentElement.classList.remove("ag-lock");
    };

    let modalOpen = false;
    let lastActive = null;

    const openModal = (cardEl) => {
      if (!modalRoot || !modalDialog) return;
      closeDrawer({ apply: false });

      const titleText = decodeHtml(cardEl.dataset.title || "");
      const themeText = decodeHtml(cardEl.dataset.themeLabel || "");
      const promptText = decodeHtml(cardEl.dataset.description || "");

      if (modalTitle) modalTitle.textContent = titleText || "Artwork";
      if (modalTheme) modalTheme.textContent = themeText || "Theme Name";
      if (modalPrompt) modalPrompt.textContent = promptText || "";

      if (modalGenerate) {
        const url = (cardEl.dataset.generateUrl || "").toString().trim();
        modalGenerate.hidden = !url || url === "#";
        if (url && url !== "#") modalGenerate.setAttribute("href", url);
      }
      if (modalPrint) {
        const url = (cardEl.dataset.printUrl || "").toString().trim();
        const label = decodeHtml(cardEl.dataset.printLabel || "Print This Design");
        modalPrint.hidden = !url || url === "#";
        if (url && url !== "#") {
          modalPrint.textContent = label.toLowerCase() === "print" ? "Print This Design" : label;
          modalPrint.setAttribute("href", url);
        }
      }

      const setIcon = (a, urlKey, labelKey) => {
        if (!a) return;
        const url = (cardEl.dataset[urlKey] || "").toString();
        const label = decodeHtml(cardEl.dataset[labelKey] || "Action");
        if (url) {
          a.hidden = false;
          a.setAttribute("href", url);
          a.setAttribute("aria-label", label);
        } else {
          a.hidden = true;
        }
      };
      setIcon(modalIconLeft, "iconLeftUrl", "iconLeftLabel");
      setIcon(modalIconRight, "iconRightUrl", "iconRightLabel");

      if (modalMedia) {
        modalMedia.textContent = "";
        const img = cardEl.querySelector("img");
        if (img) {
          const clone = img.cloneNode(true);
          clone.removeAttribute("loading");
          clone.decoding = "async";
          modalMedia.appendChild(clone);
        }
      }

      lastActive = document.activeElement;
      modalRoot.hidden = false;
      modalOpen = true;
      document.documentElement.classList.add("ag-lock");
      modalDialog.focus();
    };

    const closeModal = () => {
      if (!modalRoot) return;
      if (!modalOpen) return;
      modalRoot.hidden = true;
      modalOpen = false;
      document.documentElement.classList.remove("ag-lock");
      if (lastActive && typeof lastActive.focus === "function") lastActive.focus();
    };

    const fetchIfDesktop = () => {
      if (isMobile() && drawerOpen) return;
      apiState.page = 1;
      renderState.clientFiltered = [];
      updateActiveFilters();
      refresh();
    };

    [...themeChecks, ...colorChecks, ...orientationChecks].forEach((i) =>
      i.addEventListener("change", () => {
        updateActiveFilters();
        fetchIfDesktop();
      })
    );

    sortByRadios.forEach((i) => i.addEventListener("change", fetchIfDesktop));
    if (sortOrder) sortOrder.addEventListener("change", fetchIfDesktop);

    themeTabBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        themeTabBtns.forEach((b) => b.classList.remove("is-active"));
        btn.classList.add("is-active");
        activeCollection = (btn.getAttribute("data-value") || "").trim();
        setUrlCollection(activeCollection);
        apiState.page = 1;
        renderState.clientFiltered = [];
        updateActiveFilters();
        refresh();
      });
    });

    if (searchInput) {
      searchInput.addEventListener("input", debounce(applySearch, 250));
      searchInput.addEventListener("search", applySearch);
    }

    const resetToDefaults = () => {
      activeCollection = "";
      themeTabBtns.forEach((b) => b.classList.remove("is-active"));
      const allTab = themeTabBtns.find((b) => (b.getAttribute("data-value") || "").trim() === "");
      if (allTab) allTab.classList.add("is-active");
      writeStateToDom({
        themes: [],
        colors: [],
        orientations: [],
        sort_by: defaultSortBy,
        sort_order: defaultSortOrder,
      });
      apiState.page = 1;
      updateActiveFilters();
    };

    if (resetTop) {
      resetTop.addEventListener("click", () => {
        resetToDefaults();
        refresh();
      });
    }

    openButtons.forEach((b) => {
      b.addEventListener("click", () => openDrawer(b.getAttribute("data-ag-open")));
    });

    // Mobile Apply — sync mobile inputs to desktop then refresh
    if (mobApplyBtn) mobApplyBtn.addEventListener("click", () => {
      syncFromMobile();
      closeDrawer({ apply: true });
      apiState.page = 1;
      renderState.clientFiltered = [];
      updateActiveFilters();
      refresh();
    });

    // Mobile Reset — clear only mobile panel inputs (desktop unchanged until Apply)
    if (mobResetBtn) mobResetBtn.addEventListener("click", () => {
      mobOrientationChecks.forEach(i => { i.checked = false; });
      let found = false;
      mobSortByRadios.forEach(r => {
        const ok = sortByToApi(r.value) === sortByToApi(defaultSortBy);
        r.checked = ok;
        if (ok) found = true;
      });
      if (!found && mobSortByRadios[0]) mobSortByRadios[0].checked = true;
      if (mobSearchInput) mobSearchInput.value = "";
    });

    if (closeBtn) closeBtn.addEventListener("click", () => closeDrawer({ apply: false }));
    if (overlay) overlay.addEventListener("click", () => closeDrawer({ apply: false }));

    prevPageBtn?.addEventListener("click", () => {
      if (apiState.busy || !apiState.hasPrevPage) return;
      apiState.page = Math.max(1, apiState.page - 1);
      if (renderState.mode === "client") {
        setStatus(null, "");
        renderClientPage();
        return;
      }
      refresh();
    });

    nextPageBtn?.addEventListener("click", () => {
      if (apiState.busy || !apiState.hasNextPage) return;
      apiState.page += 1;
      if (renderState.mode === "client") {
        setStatus(null, "");
        renderClientPage();
        return;
      }
      refresh();
    });

    pagerNumbers?.addEventListener("click", (e) => {
      const target = e.target;
      if (!(target instanceof Element)) return;
      const btn = target.closest("[data-page]");
      if (!btn) return;
      if (apiState.busy) return;
      const nextPage = Number(btn.getAttribute("data-page"));
      if (!Number.isFinite(nextPage) || nextPage < 1 || nextPage === apiState.page) return;
      apiState.page = Math.floor(nextPage);
      if (renderState.mode === "client") {
        setStatus(null, "");
        renderClientPage();
        return;
      }
      refresh();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;
      if (modalOpen) {
        closeModal();
        return;
      }
      if (drawerOpen) closeDrawer({ apply: false });
    });

    window.addEventListener("resize", debounce(() => {
      if (!drawerOpen) return;
      if (!isMobile()) closeDrawer({ apply: false });
    }, 100));

    if (grid) {
      grid.addEventListener("click", (e) => {
        const target = e.target;
        if (!(target instanceof Element)) return;
        const a = target.closest("[data-ag-details]");
        if (!a) return;
        e.preventDefault();
        const card = a.closest("[data-ag-card]");
        if (card) openModal(card);
      });

      // Mobile tap: toggle print button visibility on the tapped card
      grid.addEventListener("click", (e) => {
        const target = e.target;
        if (!(target instanceof Element)) return;
        if (target.closest(".ag__printOverlay")) return; // let print clicks through
        const card = target.closest("[data-ag-card]");
        if (!card) return;
        const wasActive = card.classList.contains("is-tapped");
        Array.from(grid.querySelectorAll("[data-ag-card].is-tapped")).forEach((c) => c.classList.remove("is-tapped"));
        if (!wasActive) card.classList.add("is-tapped");
      });
    }

    // Dismiss tapped card when clicking outside the grid
    document.addEventListener("click", (e) => {
      if (!(e.target instanceof Element)) return;
      if (!e.target.closest("[data-ag-card]") && grid) {
        Array.from(grid.querySelectorAll("[data-ag-card].is-tapped")).forEach((c) => c.classList.remove("is-tapped"));
      }
    });

    if (activeList) {
      activeList.addEventListener("click", (e) => {
        const target = e.target;
        if (!(target instanceof Element)) return;
        const chip = target.closest("[data-ag-chip]");
        if (!chip) return;

        const kind = (chip.getAttribute("data-kind") || "").toString();
        const value = (chip.getAttribute("data-value") || "").toString();

        if (kind === "sort") {
          // "Close" on sort chip resets sort back to section defaults.
          applySortDefaults();

          apiState.page = 1;
          updateActiveFilters();
          refresh();
          return;
        }

        const want = normalize(value);

        const uncheck = (inputs) => {
          inputs.forEach((i) => {
            if (normalize(i.value) === want) i.checked = false;
          });
        };

        if (kind === "theme") uncheck(themeChecks);
        else if (kind === "color") uncheck(colorChecks);
        else if (kind === "orientation") uncheck(orientationChecks);
        else return;

        apiState.page = 1;
        updateActiveFilters();
        refresh();
      });
    }

    clearAll?.addEventListener("click", () => {
      themeChecks.forEach((i) => (i.checked = false));
      colorChecks.forEach((i) => (i.checked = false));
      orientationChecks.forEach((i) => (i.checked = false));
      applySortDefaults();
      apiState.page = 1;
      renderState.clientFiltered = [];
      updateActiveFilters();
      refresh();
    });

    if (modalClose) modalClose.addEventListener("click", closeModal);
    if (modalOverlay) modalOverlay.addEventListener("click", closeModal);

    if (grid) grid.textContent = "";
    applySortDefaults();

    // Restore collection filter from URL param (e.g. ?collection=freedom-collection)
    const _urlCol = (new URLSearchParams(window.location.search).get("collection") || "").toLowerCase().trim();
    if (_urlCol) {
      const _matchTab = themeTabBtns.find((b) => slugify((b.getAttribute("data-value") || "").trim()) === _urlCol);
      if (_matchTab) {
        themeTabBtns.forEach((b) => b.classList.remove("is-active"));
        _matchTab.classList.add("is-active");
        activeCollection = (_matchTab.getAttribute("data-value") || "").trim();
      }
    }

    updateActiveFilters();
    refresh();
  };

  const boot = () => {
    document.querySelectorAll("[data-ag-section]").forEach(initSection);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

function generationProcess(description, theme) {
    const themeCode = toSnakeCase(theme);
      navigator.clipboard.writeText(description).catch(() => {
            const ta = document.createElement('textarea');
            ta.value = description;
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
        });
    localStorage.setItem("Image-Info", JSON.stringify({"Prompt": description, "Theme": themeCode}));
    
    setTimeout(() => {
        const currentParams = new URLSearchParams(window.location.search);
        currentParams.set('prompt', 'true');
        window.location.href = `/pages/photo-to-canvas?mode=generate&${currentParams.toString()}`;
    }, 350);
}
  function toSnakeCase(text) {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, '') // remove special chars (optional)
    .trim()
    .replace(/\s+/g, '_'); // replace spaces with underscore
}

  function purchaseProcess(mainImageLink){
    localStorage.setItem("frame-select-img", mainImageLink);
    
        window.location.href = "/products/canvas?syncMode=pdp-select";
  }

document.addEventListener("click", function (event) {
  
  const modalGenerateBtn = event.target.closest(".agModal__action--ghost");
  if (!modalGenerateBtn) return;
  const modal = document.querySelector("[data-ag-modal]");
  const prompt = modal.querySelector("[data-ag-modal-prompt]")?.innerText || "";
  const theme = modal.querySelector("[data-ag-modal-theme]")?.innerText || "";
  generationProcess(prompt , theme);
});

document.addEventListener("click", function (event) {

  const modalPrintBtn = event.target.closest(".agModal__action--print");
  if (!modalPrintBtn) return;
  const modal = document.querySelector("[data-ag-modal]");
  const imgElement = modal.querySelector(".ag__img");
  const img = imgElement.dataset.highQualityMainImage;
  purchaseProcess(img);
});

})();


